/**
 * Consent Gates - Manages third-party script loading based on user consent
 * Listens for trackingConsentAccepted event and initializes gated scripts
 */
(function() {
  'use strict';

  var GTM_ID = 'GTM-MQ56T22';
  var scriptsLoaded = {
    gtm: false
  };

  /**
   * Load Google Tag Manager
   */
  function loadGTM() {
    if (scriptsLoaded.gtm) return;
    
    // Initialize dataLayer if it doesn't exist
    window.dataLayer = window.dataLayer || [];
    
    // Load GTM script
    (function(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),
          dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',GTM_ID);
    
    scriptsLoaded.gtm = true;
  }

  /**
   * Load GTM noscript iframe
   */
  function loadGTMNoscript() {
    if (document.getElementById('gtm-noscript')) return;
    
    var noscript = document.createElement('noscript');
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + GTM_ID;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    iframe.id = 'gtm-noscript';
    noscript.appendChild(iframe);
    
    // Insert after opening body tag
    var body = document.body;
    if (body) {
      body.insertBefore(noscript, body.firstChild);
    }
  }

  /**
   * Initialize all gated scripts
   */
  function initAll() {
    // Check if consent is already granted
    if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.userCanBeTracked()) {
      loadGTM();
      loadGTMNoscript();
      return;
    }
    
    // Otherwise wait for consent event
    document.addEventListener('trackingConsentAccepted', function() {
      loadGTM();
      loadGTMNoscript();
    });
  }

  // Initialize on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();

